import { CiLock } from "@onemind-services-llc/react-icons-ng/ci";
import { MdOutlineSensors } from "@onemind-services-llc/react-icons-ng/md";
import {
  HiOutlineServerStack,
  HiOutlineCloud,
} from "@onemind-services-llc/react-icons-ng/hi";
import { MAIN_ROUTES } from "@/constants/routes";

export const SOLUTIONS_COMP = {
  LeftPanel: {
    title: "Empowering Businesses with Next-Gen IT Solutions",
    content: [
      "We offer a comprehensive suite of services, including cloud hosting, application deployment, and scalable storage solutions for modern cloud platforms. Our platform is designed to transform your workload with powerful computing capabilities, innovative container services, and robust disaster recovery options. Experience seamless scalability and high performance with our state-of-the-art virtual machines, Kubernetes as a Service, and fully automated storage clusters.",
      "Our user-friendly control panel ensures you spend more time coding and less time managing your infrastructure.",
      "Join thousands of clients who have deployed over 45 million instances with Onemind services.",
    ],
    button: {
      label: "Contact Us",
      link: MAIN_ROUTES.BOOK_A_CONSULTATION,
    },
    conclusion:
      "With cutting-edge technology and industry expertise, we help businesses optimize performance, minimize risks, and drive digital transformation.",
  },
  RightPanel: {
    features: [
      {
        icon: HiOutlineCloud,
        title: "Cloud Infrastructure & Management",
        content:
          "Secure, scalable, and cost-effective IaaS & PaaS solutions for seamless cloud platform transformation trusted by leading msp providers.",
        button: {
          label: "Explore More",
          link: MAIN_ROUTES.CLOUD_SERVICES,
        },
      },
      {
        icon: CiLock,
        title: "Advanced Cybersecurity & Compliance",
        content:
          "End-to-end data protection, threat monitoring, and regulatory compliance for enhanced security.",
        button: {
          label: "Explore More",
          link: MAIN_ROUTES.SECURITY_SERVICES,
        },
      },
      {
        icon: MdOutlineSensors,
        title: "IoT & Smart Solutions",
        content:
          "Custom-built IoT applications with real-time analytics, automation, and AI-driven insights.",
        button: {
          label: "Explore More",
          link: `${MAIN_ROUTES.NETWORK_SERVICES}`,
        },
      },
      {
        icon: HiOutlineServerStack,
        title: "Datacenter Excellence",
        content:
          "Enterprise-grade hosting, networking, and storage solutions backed by a 99.99% SLA and 24/7 support.",
        button: {
          label: "Explore More",
          link: `${MAIN_ROUTES.DATA_CENTER}`,
        },
      },
    ],
    conclusion:
      "With cutting-edge technology and industry expertise, we help businesses optimize performance, minimize risks, and drive digital transformation.",
  },
};
